import React from "react";
import { Box, Typography, Grid } from "@mui/material";
import { AiOutlineInfoCircle } from "react-icons/ai";
import SearchItem from "../SearchItem";
import { PALETTE } from "../../Theme/Palette";

function Result({ data }) {
  return (
    <Box display="flex" flexDirection="column" alignItems="center" width="100%">
      <Box
        display={{ xs: "flex", sm: "flex", md: "none" }}
        justifyContent="flex-start"
        alignItems="center"
        sx={{ boxSizing: "border-box", padding: "1rem" }}
      >
        <Typography
          variant="h2"
          textAlign="right"
          float="right"
          marginRight="1rem"
          sx={{ boxSizing: "border-box", paddingLeft: 3 }}
        >
          با انتخاب هر کد همسان ، کد انتخابی به لیست "کاندیدهای همسانی" اضافه می‌گردد. در بخش
          "کاندیدهای همسانی" شما می‌توانید حداکثر 3 گزینه را انتخاب و به مرکز ارسال نمائید.
        </Typography>
        <AiOutlineInfoCircle
          color={PALETTE.eightth}
          fontSize="1.5rem"
          style={{ minWidth: "1.3rem" }}
        />
      </Box>
      <Box
        width="100%"
        display="flex"
        alignItems="center"
        justifyContent="flex-end"
        marginBottom={2}
        sx={{ boxSizing: "border-box", padding: "1rem" }}
      >
        <Typography variant="h2">نتایج جستجو</Typography>
      </Box>
      <Grid item marginLeft="auto" marginRight={{ lg: "80px", md: "65px", sm: "75px", xs: "65px" }}>
        <Typography variant="h2" color="#AAAAAA" textAlign="right" mt={1}>
          کد همسان
        </Typography>
      </Grid>
      <Box width="95%">
        {data.map((item) => (
          <SearchItem
            key={item.number}
            birthDate={item.birthDate}
            isCandidate={item.isCandidate}
            commitmentRateName={item.commitmentRateName}
            residenceCityName={item.residenceCityName}
            educationDegree={item.educationDegree}
            number={item.number}
          />
        ))}
      </Box>
    </Box>
  );
}

export default Result;
